import { ItemType } from "../types";

export const typeIcons: Record<ItemType, string> = {
  person: "👤",
  event: "📅",
  product: "📦",
  project: "🛠️",
  service: "🛎️",
  creative: "🎨",
  organization: "🌐",
  article: "📰",
  course: "🎓",
};
